/* External Packages */
// jQuery Helper
import './scripts/jqueryLib';

/* Internal Files */
import general from './scripts/general.js';

document.addEventListener('DOMContentLoaded', function () {
    general();
});
